import React from 'react'
import Type from "../aside/Type"

export default function MoveItem({move}) {
  if(!move){
    return<div></div>
  }
  return (
    <div className="move-item">
      <div className="move-type">
        <Type type={move.type.name}></Type>
      </div>
      <div className="move-data">
       <div>{move.name.toUpperCase()}</div>
        <div className="move-pp">{move.pp}/{move.pp}</div> 
      </div>
    </div>
  )
}
